import React, { useEffect, useState } from "react";

const ProfilCheckOption = ({ checked, title, name, label, onCheck }) => {
    return (
        <div className={"d-flex flex-column justify-content-start w-100 mb-1"}>
            <div
                className={
                    "d-flex justify-content-between align-items-center p-2 w-100 rounded"
                }
                style={{ backgroundColor: "var(--theme-gray-bg-input)" }}
            >
                <div className={""}>{title}</div>
                <div className="custom-control custom-switch">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        style={{ cursor: "pointer" }}
                        checked={checked}
                        onChange={onCheck}
                        id={name}
                        name={name}
                    />
                    <label
                        className="custom-control-label ue-check-service-label"
                        htmlFor={name}
                    >
                        {""}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default ProfilCheckOption;
